import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import Img1 from "../../../images/podcast/Applepodcast.jpg";
import Img2 from "../../../images/podcast/TuneInBig.jpg";
import Img3 from "../../../images/podcast/CastBoxBig.jpg";
import Img4 from "../../../images/podcast/PlayerFMBig.jpg";
import Img5 from "../../../images/podcast/listenon.jpg";
import Img6 from "../../../images/podcast/ListenNotesBig.jpg";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Episodesection(props) {
    return (
        <div className="podcast_story p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="m-auto text-center">
                        <h5 className="episode_name">
                            Season1 Episode#01
                        </h5>
                        <div className="iframe_section">
                            <div>
                                <iframe
                                    style={{ border: "none" }}
                                    src="//html5-player.libsyn.com/embed/episode/id/13983659/height/90/theme/custom/thumbnail/yes/direction/backward/render-playlist/no/custom-color/ef5123/"
                                    height="90"
                                    width="100%"
                                    scrolling="no"
                                    allowFullScreen
                                    webkitallowfullscreen
                                    mozallowfullscreen
                                    oallowfullscreen
                                    msallowfullscreen
                                ></iframe>
                            </div>
                        </div>
                        <Row>
                            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 text-center">
                                <Link to= "https://podcasts.apple.com/us/podcast/technology-for-change/id1510403726" target="_blank" rel="noopener">
                                    <LazyLoadImage
                                        src={Img1}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </Link>
                            </Col>
                            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 text-center">
                                <Link to= "https://tunein.com/podcasts/Business--Economics-Podcasts/Technology-For-Change-How-Steve-Built-A-Successfu-p1315217/" target="_blank" rel="noopener">
                                    <LazyLoadImage
                                        src={Img2}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </Link>
                            </Col>
                            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 text-center">
                                <Link to= "https://castbox.fm/channel/Technology-For-Change-id2766519?country=us" target="_blank" rel="noopener">
                                    <LazyLoadImage
                                        src={Img3}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </Link>
                            </Col>
                            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 text-center">
                                <Link to ="https://player.fm/series/technology-for-a-change" target="_blank" rel="noopener">
                                    <LazyLoadImage
                                        src={Img4}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </Link>
                            </Col>
                            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 text-center">
                                <Link to ="https://podcasts.google.com/feed/aHR0cDovL2ZlZWRzLmxpYnN5bi5jb20vMjYyNDkzL3Jzcw/episode/OTM2YmVhMjEtNDhmNy00YWI0LWE5NWItNzAzM2Y1OTFkZWY5?sa=X&ved=0CAgQuIEEahcKEwjA-ueIwc75AhUAAAAAHQAAAAAQLA" target="_blank" rel="noopener">
                                    <LazyLoadImage
                                        src={Img5}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </Link>
                            </Col>
                            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 text-center">
                                <Link to ="https://www.listennotes.com/podcasts/technology-for-change-abeer-raza-qPmunkLMcG6/" target="_blank" rel="noopener">
                                    <LazyLoadImage
                                        src={Img6}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                </Link>
                            </Col>
                        </Row>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Episodesection;